const STAT_CARDS = [
  { key: "therapies_total",           label: "Total therapies" },
  { key: "therapies_published",       label: "Published" },
  { key: "pending_medical_review",    label: "Pending medical" },
  { key: "pending_compliance_review", label: "Pending compliance" },
  { key: "consultation_requests",     label: "Consult requests" },
];

export function AdminStats({ analytics }) {
  return (
    <div className="grid md:grid-cols-5 gap-4 mb-8">
      {STAT_CARDS.map(({ key, label }) => (
        <div key={key} className="vv-card p-5">
          <div className="text-xs uppercase tracking-widest text-stone-500">{label}</div>
          <div className="font-display text-3xl mt-1">{analytics[key]}</div>
        </div>
      ))}
    </div>
  );
}

export function PhoneConversions({ analytics }) {
  const rows = analytics.phone_clicks_by_cta || [];
  const max = rows.length ? Math.max(...rows.map((x) => x.count)) : 0;
  return (
    <div className="vv-card p-6 mb-8">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest text-stone-500">Phone conversions</div>
          <div className="font-display text-3xl mt-1">{analytics.phone_clicks_total || 0}</div>
          <div className="text-xs text-stone-500 mt-1">Total tap-to-call clicks across the site</div>
        </div>
        <div className="flex-1 min-w-[280px]">
          <div className="text-xs uppercase tracking-widest text-stone-500 mb-2">By CTA location</div>
          {rows.length === 0 ? (
            <div className="text-sm text-stone-500">No calls yet.</div>
          ) : (
            <div className="space-y-1.5">
              {rows.map((r) => {
                const pct = max > 0 ? Math.round((r.count / max) * 100) : 0;
                return (
                  <div key={r.cta_location} className="flex items-center gap-3 text-sm">
                    <div className="w-40 truncate text-stone-600">{r.cta_location}</div>
                    <div className="flex-1 h-2 bg-stone-100 rounded-full overflow-hidden">
                      <div className="h-full bg-[color:var(--vv-teal)]" style={{ width: `${pct}%` }}></div>
                    </div>
                    <div className="w-8 text-right text-stone-700 font-medium">{r.count}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
